import React from 'react'

const Spinner = () => (
  <div className="spinner">
    <span />
    <span />
    <span />
  </div>
)

export default Spinner
